import comp from "./DeleteTagModal";
export default comp;
